import { SaveButton } from "components/Buttons"
import {
  AsyncTypeahedSelect,
  CheckboxField,
  RadioField,
} from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import {
  Field,
  FormSection,
  formValueSelector,
  initialize,
  reduxForm,
} from "redux-form"
import {
  getMetaTags,
  getUsersBySearch,
  getVideoCallSetup,
  resetVideoCallSetup,
  updateVideoCallSetup,
} from "store/actions"
import { mapApiToVideoCallForm, mapVideoCallFormToApi } from "../utils"
import { LoadingIndicator } from "components/LoadingIndicator"

const VideoCall = props => {
  useEffect(() => {
    props?.getMetaTags({ hide_for_business_unit: 1 })
    props.getVideoCallSetup({
      dashboard: true,
      event_id: props?.selectedEvent?.id,
      menu_item_id: props?.feature?.id,
    })
    return () => {
      props.resetVideoCallSetup()
    }
  }, [])

  useEffect(() => {
    if (props?.videoCall) {
      props.initializeForm(mapApiToVideoCallForm(props?.videoCall))
    }
  }, [props.videoCall])

  const saveHandler = data => {
    props.updateVideoCallSetup({
      ...props?.videoCall,
      ...mapVideoCallFormToApi(data),
    })
  }

  return (
    <FormSection name={props.form}>
      {props?.loading ? (
        <LoadingIndicator />
      ) : (
        <Card>
          <CardBody className="shadow-sm">
            <Row className="mb-3">
              <Col xl={10}>
                <h3>{props.feature.label}</h3>
              </Col>
            </Row>
            <Row>
              <Col>
                <Card>
                  <CardHeader>
                    <h5>WHICH USER(S) CAN RECEIVE VIDEO CALLS?</h5>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col xs={12} className="my-1">
                        <Field
                          name="receivers"
                          value="all"
                          type="radio"
                          label="All Users"
                          component={RadioField}
                        />
                      </Col>
                      <Col xs={12} className="my-1">
                        <Field
                          name="receivers"
                          value="users"
                          type="radio"
                          label="Selected Users"
                          component={RadioField}
                        />
                      </Col>
                      <Col xs={12} className="my-1">
                        <Field
                          name="receivers"
                          value="tags"
                          type="radio"
                          label="Selected Tags"
                          component={RadioField}
                        />
                      </Col>
                      {props.receivers === "users" && (
                        <Col xs={12} className="my-2">
                          <Field
                            name="userSearch"
                            component={AsyncTypeahedSelect}
                            placeholder="Search for specific users"
                            options={props.usersBySearch.map(user => ({
                              ...user,
                              label: `${user.first_name} ${user.last_name} (${user.email})`,
                              value: user.id,
                            }))}
                            inlineValue={false}
                            onInputChange={text =>
                              props.getUsersBySearch({
                                t: text,
                                event_id: props?.selectedEvent?.id,
                                include_admins: true,
                              })
                            }
                            isMulti={true}
                            onMenuClose={() => {
                              props.getUsersBySearch({
                                event_id: props?.selectedEvent?.id,
                                include_admins: true,
                              })
                            }}
                          />
                        </Col>
                      )}
                      {props.receivers === "tags" && (
                        <Col xs={12} className="my-2">
                          <Field
                            name="tagSearch"
                            placeholder="Enter tag"
                            component={AsyncTypeahedSelect}
                            options={props?.metaTags.map(tag => ({
                              ...tag,
                              label: tag.tag,
                              value: tag.id,
                            }))}
                            isMulti={true}
                          />
                        </Col>
                      )}
                    </Row>
                  </CardBody>
                </Card>
                <Card>
                  <CardHeader>
                    <h5>SELECT A VIDEO CALLS ADMIN(S)</h5>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col>
                        <Field
                          name="adminSetupEnabled"
                          component={CheckboxField}
                          label={"SELECT A VIDEO CALLS ADMIN(S)"}
                          onChange={(event, newValue) => {
                            if (newValue) {
                              props?.change(
                                "video_call_form.adminUsers",
                                "users"
                              )
                              props?.change(
                                "video_call_form.adminReceivers",
                                "all"
                              )
                            } else {
                              props?.change(
                                "video_call_form.adminUsers",
                                "none"
                              )
                            }
                          }}
                        />
                      </Col>
                    </Row>
                    {props?.adminSetupEnabled && (
                      <>
                        <Row className="mt-2">
                          <Col xs={12} className="my-1">
                            <Field
                              name="adminUsers"
                              value="users"
                              type="radio"
                              label="Select user(s) to be VIDEO CALL Admin"
                              component={RadioField}
                            />
                          </Col>
                          <Col xs={12} className="my-1">
                            <Field
                              name="adminUsers"
                              value="tags"
                              type="radio"
                              label="Select tagged user(s) to be your VIDEO CALL Admin"
                              component={RadioField}
                            />
                          </Col>
                          {props?.adminUsers === "users" && (
                            <Col xs={12} className="my-2">
                              <Field
                                name="adminUserSearch"
                                component={AsyncTypeahedSelect}
                                placeholder="Search for specific users"
                                options={props.usersBySearch.map(user => ({
                                  ...user,
                                  label: `${user.first_name} ${user.last_name} (${user.email})`,
                                  value: user.id,
                                }))}
                                inlineValue={false}
                                onInputChange={text =>
                                  props.getUsersBySearch({
                                    t: text,
                                    event_id: props?.selectedEvent?.id,
                                    include_admins: true,
                                  })
                                }
                                isMulti={true}
                                onMenuClose={() => {
                                  props.getUsersBySearch({
                                    event_id: props?.selectedEvent?.id,
                                    include_admins: true,
                                  })
                                }}
                              />
                            </Col>
                          )}
                          {props?.adminUsers === "tags" && (
                            <Col xs={12} className="my-2">
                              <Field
                                name="adminTagSearch"
                                placeholder="Enter tag"
                                component={AsyncTypeahedSelect}
                                options={props?.metaTags.map(tag => ({
                                  ...tag,
                                  label: tag.tag,
                                  value: tag.id,
                                }))}
                                isMulti={true}
                              />
                            </Col>
                          )}
                        </Row>
                        <Row className="mt-3">
                          <Col xs={12}>
                            <h5>
                              To whom can a Video Call Admin start a Video Call?
                            </h5>
                          </Col>
                          <Col xs={12} className="my-1">
                            <Field
                              name="adminReceivers"
                              value="all"
                              type="radio"
                              label="All Users"
                              component={RadioField}
                            />
                          </Col>
                          <Col xs={12} className="my-1">
                            <Field
                              name="adminReceivers"
                              value="users"
                              type="radio"
                              label="Selected Users"
                              component={RadioField}
                            />
                          </Col>
                          <Col xs={12} className="my-1">
                            <Field
                              name="adminReceivers"
                              value="tags"
                              type="radio"
                              label="Selected Tags"
                              component={RadioField}
                            />
                          </Col>
                          {props?.adminReceivers === "users" && (
                            <Col xs={12} className="my-2">
                              <Field
                                name="adminReceiverUserSearch"
                                component={AsyncTypeahedSelect}
                                placeholder="Search for specific users"
                                options={props.usersBySearch.map(user => ({
                                  ...user,
                                  label: `${user.first_name} ${user.last_name} (${user.email})`,
                                  value: user.id,
                                }))}
                                inlineValue={false}
                                onInputChange={text =>
                                  props.getUsersBySearch({
                                    t: text,
                                    event_id: props?.selectedEvent?.id,
                                    include_admins: true,
                                  })
                                }
                                isMulti={true}
                                onMenuClose={() => {
                                  props.getUsersBySearch({
                                    event_id: props?.selectedEvent?.id,
                                    include_admins: true,
                                  })
                                }}
                              />
                            </Col>
                          )}
                          {props?.adminReceivers === "tags" && (
                            <Col xs={12} className="my-2">
                              <Field
                                name="adminReceiverTagSearch"
                                placeholder="Enter tag"
                                component={AsyncTypeahedSelect}
                                options={props?.metaTags.map(tag => ({
                                  ...tag,
                                  label: tag.tag,
                                  value: tag.id,
                                }))}
                                isMulti={true}
                              />
                            </Col>
                          )}
                        </Row>
                      </>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row className="d-flex justify-content-center">
              <Col xs="auto">
                <SaveButton
                  type="button"
                  content="Save"
                  onClick={props.handleSubmit(saveHandler)}
                />
              </Col>
            </Row>
          </CardBody>
        </Card>
      )}
    </FormSection>
  )
}

const selector = formValueSelector(FORM_NAMES.VIDEO_CALL)

const mapStateToProps = state => ({
  videoCall: state.VideoCall.videoCall,
  loading: state.VideoCall.loading,
  selectedEvent: state.experiences.selectedEvent,
  receivers: selector(state, "video_call_form.receivers"),
  usersBySearch: state.SiteUsers.usersBySearch,
  adminReceivers: selector(state, "video_call_form.adminReceivers"),
  adminSetupEnabled: selector(state, "video_call_form.adminSetupEnabled"),
  adminUsers: selector(state, "video_call_form.adminUsers"),
  metaTags: state.Tags.metaTags,
})

const mapDispatchToProps = dispatch => ({
  getVideoCallSetup: values => dispatch(getVideoCallSetup(values)),
  resetVideoCallSetup: () => dispatch(resetVideoCallSetup()),
  initializeForm: values => dispatch(initialize(FORM_NAMES.VIDEO_CALL, values)),
  updateVideoCallSetup: values => dispatch(updateVideoCallSetup(values)),
  getUsersBySearch: values => dispatch(getUsersBySearch(values)),
  getMetaTags: values => dispatch(getMetaTags(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({ form: FORM_NAMES.VIDEO_CALL })(VideoCall))
